import store from '@/store'
import { ref } from '@vue/composition-api'

export default function useBookmark_lang_skin() {

  const requestStatus = ref(false)

  const bookmark = bookmarks => {
    requestStatus.value = true
    store.dispatch('auth/bookmark', bookmarks)
      .then(res => requestStatus.value = false)
      .catch(reason => requestStatus.value = false)
  }

  const skinToggle = (dark, callback) => {
    requestStatus.value = true
    store.dispatch('auth/skin', dark)
      .then(res => callback())
      .catch(reason => callback())
  }


  const langToggle = (lang, callback) => {
    store.dispatch('auth/lang', lang)
      .then(res => callback())
      .catch(reason => callback())
  }

  return {
    bookmark,
    skinToggle,
    langToggle,
    requestStatus
  }
}
